module.exports = __webpack_public_path__ + "img/icon-link-url-0.72af9766.svg";